//import Immutable from "immutable"
import CommonUtils from "@tinqin/tinqin-utils/src/common";

export default function(a, b) {
    var result;

    //result = Immutable.is(Immutable.fromJS(a), Immutable.fromJS(b));

    result = CommonUtils.isEqual(a, b);

    return result;
}
